import { createStyles } from 'antd-style';

import {
  ThemeBorderRadius,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
} from '../../../../theme';

export const useAdminAccountPickListCardStyles = createStyles(
  ({ token }, transferStyles) => ({
    transfer: {
      padding: ThemeSpaces.SPACE_NORM_20,
      paddingBottom: token.paddingMD,
      height: 'calc(100vh - 320px)',
      minHeight: 240,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',

      '.ant-form-item, .ant-form-item-row, .ant-form-item-control, .ant-form-item-control-input, .ant-form-item-control-input-content':
        {
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 auto',
          minHeight: 0,
          width: '100%',
        },

      '.ant-transfer-list': {
        border: 'none',
        boxShadow: `1px 1px 6px 0 ${ThemeColors.COLOR_GREY_BLUISH}`,
        borderRadius: ThemeBorderRadius.BORDER_RADIUS_BASE,

        '.ant-transfer-list-header': {
          height: 30,
          border: 'none',
          backgroundColor: ThemeColors.COLOR_GREY_BLUISH,
          padding: ThemeSpaces.SPACE_NORM,
          borderRadius: `${ThemeBorderRadius.BORDER_RADIUS_BASE}px ${ThemeBorderRadius.BORDER_RADIUS_BASE}px 0 0`,

          '.ant-transfer-list-header-title': {
            textAlign: 'start',
          },

          '> span': {
            fontFamily: ThemeFont.FONT_CONDENSED,
            fontWeight: 700,
            fontSize: token.fontSize,
            color: token.colorWhite,
          },
        },

        '.ant-transfer-list-body': {
          position: 'relative',

          '.ant-transfer-list-body-search-wrapper': {
            backgroundColor: ThemeColors.COLOR_GREY9_9,
            borderTop: 'none',
            padding: `${ThemeSpaces.SPACE_NORM_15}px ${ThemeSpaces.SPACE_NORM_20}px ${ThemeSpaces.SPACE_NORM_15}px ${ThemeSpaces.SPACE_NORM_50}px`,
            borderBottom: `1px solid ${ThemeColors.COLOR_GREY_BLUISH}`,

            '.ant-transfer-list-search': {
              boxShadow: '0 1px 3px 0 inset rgba(0, 0, 0, 0.5)',
              height: 30,

              ' input': {
                fontSize: token.fontSize,
                color: `${ThemeColors.COLOR_GREY11} !important`,

                '&::placeholder': {
                  fontWeight: 400,
                  color: ThemeColors.COLOR_GREY11,
                },
              },
            },
          },

          [`.${transferStyles.transferRow}`]: {
            borderBottom: `1px solid ${ThemeColors.COLOR_GREY8_1}`,
            height: 40,
            color: ThemeColors.COLOR_GREY3,
          },

          '.ant-checkbox-wrapper': {
            height: 40,
            color: ThemeColors.COLOR_GREY3,
            fontSize: token.fontSize,

            '.ant-checkbox-inner': {
              borderColor: ThemeColors.COLOR_GREY3,
              borderRadius: token.borderRadiusXS,
              backgroundColor: ThemeColors.COLOR_WHITE6,
            },

            '.ant-checkbox-checked .ant-checkbox-inner': {
              backgroundColor: token.colorPrimary,
              borderColor: token.colorPrimary,
            },
          },

          '.transfer-select-all': {
            position: 'absolute',
            top: 15,
            left: 20,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            zIndex: 1,
          },

          '.Scrollbar .Scrollbar-TrackVertical': {
            top: 4,
            bottom: 4,
          },
        },
      },

      '.ant-transfer': {
        flex: '1 1 auto',
        minHeight: 0,

        '&.qol-input-view-mode .ant-transfer-list-body .ant-transfer-list-body-search-wrapper':
          {
            paddingLeft: ThemeSpaces.SPACE_NORM_20,
          },

        '.ant-transfer-operation': {
          margin: `0 ${ThemeSpaces.SPACE_NORM_20}px`,

          '.ant-btn.ant-btn, .ant-btn.ant-btn:hover, .ant-btn.ant-btn:active': {
            color: token.colorPrimary,
            border: 'none',
            boxShadow: `1px 1px 6px 0 ${ThemeColors.COLOR_GREY_BLUISH}`,

            '&:focus': {
              color: token.colorWhite,
              backgroundColor: token.colorPrimary,
              border: 'none',
            },

            '.ant-btn-icon': {
              display: 'none',
            },
          },
        },
      },
    },
  })
);
